import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export { createRichTextSchema, hasTextContent, htmlToPlainText, normalizeEditorContent, resolveRichTextDoc, richTextToHtml, sanitizeRichTextDoc, escapeHtmlCharacters, } from './html';
export { slugify } from './slugify';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function getInitials(name) {
    return (name || '')
        .split(' ')
        .map((n) => n[0])
        .join('');
}
export const tidyString = (name) => {
    let newString = name.replace(/([A-Z])/g, ' $1');
    newString = newString.replace(/-/g, ' ');
    return newString.charAt(0).toUpperCase() + newString.slice(1);
};
export const toSentenceCase = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
};
const customerId = '1idTVd29bEnX9cJqeKj';
export const brandFetchLoader = ({ src, width }) => {
    return `https://cdn.brandfetch.io/${src}/icon/theme/dark/fallback/lettermark/w/${width}/h/${width}?c=${customerId}`;
};
export function formatNumber(value) {
    return new Intl.NumberFormat('en-US').format(value);
}
export function formatPercentage(percentage) {
    return `${Math.round(percentage * 1000) / 10}%`;
}
